import { useState } from "react";
import axios from "axios";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";
import Quill from "quill";




/* ================================
   1. SIZE CONFIG
================================ */
const Size = Quill.import("attributors/style/size");

Size.whitelist = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "24px",
  "32px",
  "48px",
  "64px",
];

Quill.register(Size, true);

/* ================================
   2. FONT CONFIG
================================ */
const Font = Quill.import("formats/font");

Font.whitelist = [
  "arial",
  "comic-sans",
  "courier-new",
  "georgia",
  "helvetica",
  "lucida",
  "roboto",
  "times-new-roman",
  "verdana",
];

Quill.register(Font, true);

/* ================================
   3. MODULES (TOOLBAR)
================================ */
const modules = {
  toolbar: [
    [{ font: Font.whitelist }],
    [{ size: Size.whitelist }],

    [{ header: [1, 2, 3, 4, 5, false] }],

    ["bold", "italic", "underline", "strike"],

    [{ color: [] }, { background: [] }],

    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],

    ["link", "image"],

    ["clean"],
  ],
};

/* ================================
   4. FORMATS
================================ */
const formats = [
  "font",
  "size",
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "bullet",
  "align",
  "link",
  "image",
];

/* ================================
   COMPONENT
================================ */
function CreatePost() {
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [category, setCategory] = useState("");
  const [content, setContent] = useState("");
  const [featuredImage, setFeaturedImage] = useState(null);
  const [status, setStatus] = useState("Published");

  const handleSubmit = async () => {
    try {
      const cleanContent = DOMPurify.sanitize(content);

      const formData = new FormData();
      formData.append("title", title);
      formData.append("slug", slug);
      formData.append("excerpt", excerpt);
      formData.append("content", cleanContent);
      formData.append("category", category);
      formData.append("status", status);

      if (featuredImage) {
        formData.append("featured_image", featuredImage);
      }

      await axios.post("http://localhost:5000/api/posts", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Post published successfully");

      setTitle("");
      setSlug("");
      setExcerpt("");
      setContent("");
      setCategory("");
      setFeaturedImage(null);
      setStatus("Published");
    } catch (err) {
      console.log(err);
      alert("Failed to publish post");
    }
  };

  return (
    <section className="min-h-screen bg-[#F5F7FA] pt-28 md:pt-32 px-4 sm:px-6 md:px-14 pb-14">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-12">
        <div>
          <p className="uppercase tracking-[5px] text-yellow-600 font-semibold text-sm mb-3">
            Admin Panel
          </p>

          <h1 className="text-3xl md:text-5xl font-bold text-[#0B1C39]">
            Create Post
          </h1>
        </div>

        <Link
          to="/admin/dashboard"
          className="bg-gray-700 text-white px-6 py-3 rounded-2xl font-semibold hover:bg-gray-800 transition text-center"
        >
          Dashboard
        </Link>
      </div>

      {/* FORM */}
      <div className="bg-white rounded-[32px] shadow-xl p-8 md:p-12 border border-gray-100">

        {/* TITLE */}
        <div className="mb-8">
          <label className="block text-gray-700 font-semibold mb-3">
            Post Title
          </label>

          <input
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {/* SLUG */}
        <div className="mb-8">
          <label className="block text-gray-700 font-semibold mb-3">
            Slug
          </label>

          <input
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
          />
        </div>

        {/* CATEGORY */}
        <div className="mb-8">
          <label className="block text-gray-700 font-semibold mb-3">
            Category
          </label>

          <select
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">Select Category</option>
            <option value="Blog">Blog / Article</option>
            <option value="Legal Guide">Legal Guide</option>
            <option value="Legal Update">Legal Update</option>
            <option value="FAQ">FAQ</option>
            <option value="Case Study">Case Study</option>
          </select>
        </div>

        {/* EXCERPT */}
        <div className="mb-8">
          <label className="block text-gray-700 font-semibold mb-3">
            Excerpt
          </label>

          <textarea
            rows="4"
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={excerpt}
            onChange={(e) => setExcerpt(e.target.value)}
          />
        </div>

        {/* IMAGE */}
        <div className="mb-8">
          <label className="block text-gray-700 font-semibold mb-3">
            Featured Image
          </label>

          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFeaturedImage(e.target.files[0])}
          />
        </div>

        {/* CONTENT */}
        <div className="mb-10">
          <label className="block text-gray-700 font-semibold mb-3">
            Content
          </label>

          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            modules={modules}
            formats={formats}
          />
        </div>

        {/* BUTTON */}
        <button
          onClick={handleSubmit}
          className="bg-[#0B3D91] text-white px-8 py-4 rounded-2xl font-semibold"
        >
          Publish Post
        </button>

      </div>
    </section>
  );
}

export default CreatePost;